export const dashboardSummary = {
  balance: 48750.32,
  balanceChange: 8.2,
  toReceive: 18420,
  toReceiveChange: 12.4,
  toPay: 9840.5,
  toPayChange: -3.1,
  monthResult: 12580.72,
  monthResultChange: 15.6,
};

export const cashFlowSeries = [
  { month: 'Abr', entradas: 42000, saidas: 28500, saldo: 13500 },
  { month: 'Mai', entradas: 38500, saidas: 31200, saldo: 7300 },
  { month: 'Jun', entradas: 45100, saidas: 29800, saldo: 15300 },
  { month: 'Jul', entradas: 50200, saidas: 34100, saldo: 16100 },
  { month: 'Ago', entradas: 47800, saidas: 32500, saldo: 15300 },
  { month: 'Set', entradas: 39200, saidas: 26620, saldo: 12580 },
];

export const revenueExpenseSeries = [
  { month: 'Abr', receitas: 42000, despesas: 28500 },
  { month: 'Mai', receitas: 38500, despesas: 31200 },
  { month: 'Jun', receitas: 45100, despesas: 29800 },
  { month: 'Jul', receitas: 50200, despesas: 34100 },
  { month: 'Ago', receitas: 47800, despesas: 32500 },
  { month: 'Set', receitas: 39200, despesas: 26620 },
];

export const executiveIndicators = [
  { id: 'fat', label: 'Faturamento do mês', value: 39200, format: 'currency', hint: '+6,2% vs mês anterior' },
  { id: 'margem', label: 'Margem', value: 32.1, format: 'percent', hint: 'Meta: 30%' },
  { id: 'desp', label: 'Despesas', value: 26620, format: 'currency', hint: '-4,1% vs mês anterior' },
  { id: 'lucro', label: 'Lucro estimado', value: 12580.72, format: 'currency', hint: 'Após impostos estimados' },
  { id: 'ticket', label: 'Ticket médio', value: 2450, format: 'currency', hint: '16 vendas no mês' },
  { id: 'clientes', label: 'Clientes ativos', value: 4, format: 'number', hint: '1 inativo' },
  { id: 'inad', label: 'Inadimplência', value: 3.1, format: 'percent', hint: 'R$ 1.200,00 em atraso' },
  { id: 'prev', label: 'Previsão de caixa', value: 57329.82, format: 'currency', hint: 'Próximos 30 dias' },
];

export const upcomingPayables = [
  {
    id: 'ap_001',
    supplier: 'Hostinger',
    description: 'Hospedagem VPS',
    dueDate: '05/09/2026',
    amount: 89.9,
    status: 'A vencer',
  },
  {
    id: 'ap_002',
    supplier: 'Google',
    description: 'Google Workspace',
    dueDate: '10/09/2026',
    amount: 72,
    status: 'A vencer',
  },
  {
    id: 'ap_003',
    supplier: 'Contabilidade Exata',
    description: 'Honorários contábeis',
    dueDate: '15/09/2026',
    amount: 450,
    status: 'A vencer',
  },
];

export const upcomingReceivables = [
  {
    id: 'ar_001',
    client: 'Empresa XPTO Tecnologia',
    description: 'Implantação módulo financeiro',
    dueDate: '05/09/2026',
    amount: 2500,
    status: 'Pendente',
  },
  {
    id: 'ar_002',
    client: 'Emsoft Solutions',
    description: 'Suporte mensal — setembro',
    dueDate: '10/09/2026',
    amount: 1500,
    status: 'Agendado',
  },
  {
    id: 'ar_005',
    client: 'Agência Horizonte',
    description: 'Consultoria de processos',
    dueDate: '20/09/2026',
    amount: 5420,
    status: 'Pendente',
  },
];

export const recentMovements = [
  {
    id: 'tx_001',
    type: 'entrada',
    label: 'Recebimento — Cliente XPTO',
    amount: 1500,
    date: '04/09/2026',
  },
  {
    id: 'tx_003',
    type: 'saida',
    label: 'Pagamento — Fornecedor ABC',
    amount: 450,
    date: '03/09/2026',
  },
  {
    id: 'tx_004',
    type: 'entrada',
    label: 'Recebimento — Emsoft Solutions',
    amount: 1500,
    date: '02/09/2026',
  },
  {
    id: 'tx_005',
    type: 'saida',
    label: 'Pagamento — Hostinger',
    amount: 89.9,
    date: '01/09/2026',
  },
];

export const cashFlowDetails = [
  {
    date: '01/09/2026',
    description: 'Saldo inicial',
    category: '—',
    inflow: 0,
    outflow: 0,
    balance: 42180.5,
  },
  {
    date: '01/09/2026',
    description: 'PIX — Agência Horizonte',
    category: 'Consultoria',
    inflow: 2500,
    outflow: 0,
    balance: 44680.5,
  },
  {
    date: '01/09/2026',
    description: 'Débito — Hostinger',
    category: 'Infraestrutura',
    inflow: 0,
    outflow: 89.9,
    balance: 44590.6,
  },
  {
    date: '02/09/2026',
    description: 'Transferência — Emsoft Solutions',
    category: 'Serviços',
    inflow: 1500,
    outflow: 0,
    balance: 46090.6,
  },
  {
    date: '03/09/2026',
    description: 'PIX — Contabilidade Exata',
    category: 'Administrativo',
    inflow: 0,
    outflow: 450,
    balance: 45640.6,
  },
  {
    date: '03/09/2026',
    description: 'PIX — Fornecedor ABC',
    category: 'Administrativo',
    inflow: 0,
    outflow: 750,
    balance: 44890.6,
  },
  {
    date: '04/09/2026',
    description: 'PIX — Empresa XPTO Tecnologia',
    category: 'Serviços',
    inflow: 2500,
    outflow: 0,
    balance: 47390.6,
  },
];
